import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
import {
  INTEGRATION_BC_CHANNELS,
  INTEGRATION_BC_TYPES,
  INTEGRATIONS,
} from 'lib/api/integrations/types';

export const IntegrationsSuccessRedirect = () => {
  const history = useHistory();
  const location = useLocation();
  const params = queryString.parse(location.search);

  React.useEffect(() => {
    if (params.integrationType !== INTEGRATIONS.PODIUM) {
      return;
    }
    const bc = new BroadcastChannel(INTEGRATION_BC_CHANNELS.PODIUM);
    bc.postMessage({
      type: INTEGRATION_BC_TYPES.PODIUM,
      origin: window.location.origin,
    });

    history.replace('/integrations/podium');
    return () => bc.close();
  }, [params.integrationType]);

  return (
    <>
      <DocumentHead title='Integrations success' />
      <PageTemplate main={<div>Success</div>} />
    </>
  );
};
